export default function Hero() {
  return (
    <section className="relative bg-[#1E3A47] overflow-hidden pt-12 md:pt-16">
      <div className="w-full flex flex-col lg:flex-row min-h-[360px] md:min-h-[460px] max-w-[1280px] mx-auto">
        {/* Texte gauche */}
        <div className="w-full lg:w-[55%] flex flex-col justify-center px-4 md:px-8 lg:px-12 py-6 md:py-10 lg:py-14">
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
            Politique de confidentialité
          </h1>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-6 max-w-xl">
            Comment nous protégeons vos données personnelles.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="tel:0374471036"
              className="inline-flex items-center justify-center gap-2 bg-[#FF6B4A] text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-[#FF8A6B] transition-colors"
            >
              <i className="ri-phone-line" />
              Appeler le 03 74 47 10 36
            </a>
            <a
              href="#devis"
              className="inline-flex items-center justify-center gap-2 border border-white/30 text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-white/10 transition-colors"
            >
              Devis gratuit
            </a>
          </div>
        </div>

        {/* Image droite */}
        <div className="w-full lg:w-[45%] relative flex items-center justify-center p-4 md:p-6 lg:p-8">
          <div className="w-full h-[280px] md:h-[360px] lg:h-[420px] rounded-2xl overflow-hidden relative">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/8949b9b9012d54eb418ce12fcf32145f.webp"
              alt="Protection des données personnelles DF PRO"
              className="w-full h-full object-cover object-top"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1E3A47]/30 via-transparent to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}